const runtimeOrigin =
	typeof window !== "undefined" && window.location?.origin
		? window.location.origin
		: "http://localhost:8080";

const API_BASE_URL =
	(process.env.REACT_APP_API_BASE_URL || "").trim() ||
	(process.env.NODE_ENV === "development" ? "http://localhost:8080" : runtimeOrigin);

export default API_BASE_URL;
